import { render, staticRenderFns } from "./EmploymentSituation.vue?vue&type=template&id=a7820ee2"
import script from "./EmploymentSituation.vue?vue&type=script&lang=js"
export * from "./EmploymentSituation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports